import QuestionChoiceForm from '@App/components/QuestionChoiceForm/QuestionChoiceForm';

function Question5Form() {
  return <QuestionChoiceForm questionId="question5" titleKey="nature-layer-title" inputPlaceholderKey="nature-layer-input-placeholder" resultsTitleKey="nature-layer-results-title" nextRoute=".." nextButtonKey="nature-layer-end-button" />;
}

export default Question5Form;
